import { AppointmentStatus } from '../enums/appointment-status.enum.js';
/** Statuses `Appointment.confirm()` refuses — an outcome can no longer be recorded. */
const TERMINAL_STATUSES = [
    AppointmentStatus.CANCELLED,
    AppointmentStatus.COMPLETED,
    AppointmentStatus.NO_SHOW,
];
/**
 * The `attendance_unconfirmed` task applies to this patient at this appointment:
 * the appointment has started, and the outcome is recorded or can still be. A
 * terminal appointment without an outcome (cancelled in advance, or closed by
 * another path) asks nothing, since it can no longer be confirmed.
 *
 * Pure and shared: the appointment task rule and the documentation view read the
 * same gate.
 */
export const isAttendanceAsked = (input) => {
    const start = new Date(input.scheduledStart).getTime();
    if (Number.isNaN(start))
        return false;
    if (start > (input.now ?? new Date()).getTime())
        return false;
    return !(input.attendance === null && TERMINAL_STATUSES.includes(input.appointmentStatus));
};
/** The `attendance_unconfirmed` task is open: asked, and no outcome recorded yet. */
export const isAttendanceUnconfirmed = (input) => input.attendance === null && isAttendanceAsked(input);
//# sourceMappingURL=attendance-confirmation.js.map